export default __webpack_public_path__ + "images/73b7bdfb7af80a851c7c47f4f02482d4.svg";